<template>
    <div class="realSort">
        <table>
            <thead>
                <tr>
                    <th>站号</th>
                    <th>站名</th>
                    <template v-for="item in elementList">
                        <th v-for="(ele,i) in item.include" @click="onSort(ele.element)" :key="ele.element + i">
                            {{ele.name}}<br/>{{item.unit}}
                            <span v-if="ele.element == sortElement">{{sort?'▼':'▲'}}</span>
                        </th>
                    </template>
                    <th>时间</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item,index) in dataList" :key="index">
                    <td>{{item.code}}</td>
                    <td>{{item.name}}</td>
                    <template v-for="el in elementList">
                        <td v-for="ele in el.include" :key="ele.element">
                            <span :class="valClass(ele.element,item[ele.element])">{{item[ele.element] || '-'}}</span>
                        </td>
                    </template>
                    <td>{{item.dateTime}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            sort: false,
            sortElement: 'Temp', //选中的要素类型序号
            elementList: [
                {
                    name: "气温",
                    unit: "℃",
                    include: [
                        {name:"实时气温",element:'Temp'},
                        {name:"实时最高温",element:'MaxTemp'},
                        {name:"实时最低温",element:'MinTemp'},
                    ]
                },
                {
                    name: "降水",
                    unit: "mm",
                    include: [
                        {name:"近1小时降水",element:'Rain1'},
                        {name:"近3小时降水",element:'Rain3'},
                        {name:"近6小时降水",element:'Rain6'},
                        {name:"近12小时降水",element:'Rain12'},
                        {name:"近24小时降水",element:'Rain24'},
                        // {name:"近48小时降水",element:'Rain48'},
                    ]
                },
                {
                    name: "风力",
                    unit: "m/s",
                    include: [{name:"平均风",element:'WindV'}, {name:"实时极大风",element:'MaxWindV'}]
                },
                {
                    name: "湿度",
                    unit: "%",
                    include: [{name:"湿度",element:'RelHum'}]
                },
                {
                    name: "能见度",
                    unit: "m",
                    include: [{name:"能见度",element:'Visib'}]
                }
            ],
            dataList: []
        };
    },
    mounted(){
        this.showData();
    },
    computed:{
        //每个元素最大最小值记录
        maxMin(){
            const obj = {};
            this.elementList.forEach(({include}) => {
                include.forEach(({element}) => {
                    const val = {};
                    const eleVals = this.dataList.map(item => item[element]);
                    val.max = Math.max(...eleVals);
                    val.min = Math.min(...eleVals);
                    obj[element] = val;
                });
            });
            return obj;
        },
    },
    methods: {
        //排序
        onSort(element) {
            this.sortElement = element;
            this.sort = !this.sort;
            this.dataList.sort(
                (a, b) => (this.sort ? -1 : 1) * (a[this.sortElement] - b[this.sortElement])
            );
        },
        //获取数据
        showData(){
            this.ajax('wxInterface/querysK',{},dataList => {
                this.dataList = dataList;
                this.dataList.sort((a, b) => (this.sort ? -1 : 1) * (a[this.sortElement] - b[this.sortElement]));
            });
        },
        //获取最大最小值class
        valClass(key,val){
            const ele = this.maxMin[key];
            if(ele.max == val){
                return key == 'Visib' ? 'minVal' : 'maxVal';
            }
            if(ele.min == val){
                return key != 'Visib' ? 'minVal' : 'maxVal';
            }
            return '';
        },
    },
};
</script>

<style lang="less" scoped>
.realSort {
    color: white;
    overflow: auto;
    padding: 10px 5px;
    box-sizing: border-box;
    table {
        width: 100%;
        border-collapse: collapse;
        > thead > tr > th {
            white-space: nowrap;
            padding: 0 5px;
            > span {
                font-size: small;
            }
        }
        > tbody {
            > tr {
                border-top: 1px solid rgba(255, 255, 255, 0.4);
                > td {
                    white-space: nowrap;
                    text-align: center;
                    padding: 5px;
                    font-size: small;

                    &:last-child{
                        padding: 5px 20px;
                    }

                    >.maxVal{
                        color: red;
                    }

                    >.minVal{
                        color: aqua;
                    }
                }
            }
        }
    }
}
</style>